module.exports = __webpack_public_path__ + "e2.no2.ad2c3f69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e2.no2.jpg
// module id = ffUR
// module chunks = 0